import React from "react"
import * as Sentry from "@sentry/react"
import ReactDOM from "react-dom/client"

import App from "./App"

import "./styles/global.css"

const sentryEnv = import.meta.env.VITE_APP_ENV
const sentryEnabled = sentryEnv === "production" || sentryEnv === "staging"

Sentry.init({
  enabled: sentryEnabled && Boolean(import.meta.env.VITE_SENTRY_DSN),
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: sentryEnv,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/clinic\.oneaihealth\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
